import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import kratos from 'lib/auth/helpers/sdk';
import {
    LoginButton,
    LoginButtons,
    LoginLayout,
    LoginLink,
} from './LoginLayout';
import {
    KratosField,
    KratosMessages,
    useKratosFlow,
} from './kratos/KratosField';

export const LoginVerifyPage = () => {
    const { t } = useTranslation('account');
    const history = useHistory();

    const flowHandler = useCallback(async (flowId: string) => {
        const { data } = await kratos.getSelfServiceVerificationFlow(flowId);
        return data;
    }, []);

    const config = useKratosFlow('verification/browser', flowHandler);
    if (!config) {
        return null;
    }

    const { link } = config.methods;
    if (!link) {
        throw new Error('Link recovery methods have been conifgured');
    }

    const { config: method } = link;
    // @ts-ignore
    const isSend = config.state === 'sent_email';

    return (
        <LoginLayout title={t('verify_email')}>
            <form noValidate action={method.action} method={method.method}>
                <KratosMessages messages={config.messages} />
                {!isSend &&
                    method.fields.map(field => {
                        return <KratosField key={field.name} {...field} />;
                    })}
                <LoginButtons>
                    {!isSend && (
                        <LoginButton type="submit">
                            {t('general:submit')}
                        </LoginButton>
                    )}
                    <LoginLink to="/login">{t('go_to_login')}</LoginLink>
                </LoginButtons>
            </form>
        </LoginLayout>
    );
};
